import {isUndefined} from 'lodash';
import {matchPath} from 'react-router-dom';
import routes from '../router';

const getRouterConfig = (pathname, key) => {
	let ret = null;
	if (Array.isArray(routes)) {
		for (let i = 0; i < routes.length; i += 1) {
			const route = routes[i];
			const match = matchPath(pathname, {
				path: route.path,
				exact: route.exact,
				strict: route.strict,
			});
			if (match !== null && !isUndefined(route[key])) {
				ret = route[key];
				break;
			}
		}
	}
	return ret;
};

export default getRouterConfig;
